import { call, put } from 'redux-saga/effects';
import UpdateUserLocaleActions from '../redux/UpdateUserLocaleRedux';
import GetMeActions from '../redux/GetMeRedux';
import { api } from './api';

export function* updateuserlocalesagas(action: any): Generator<any, void, any> {
  const { locale } = action;
  console.log('UpdateUserLocaleSaga: Frontend locale requested:', locale);
  
  // Map frontend language keys to server language keys
  let serverLocale = locale;
  if (locale === 'zh') {
    serverLocale = 'hk'; // Server expects 'hk' for Chinese
    console.log('UpdateUserLocaleSaga: Mapped zh -> hk for server');
  } else if (locale === 'en') {
    serverLocale = 'en'; // Server expects 'en' for English
    console.log('UpdateUserLocaleSaga: Using en for server');
  } else {
    console.warn('UpdateUserLocaleSaga: Unknown locale, using as-is:', locale);
  }
  
  console.log('UpdateUserLocaleSaga: Sending to server:', serverLocale);
  
  const response = yield call(api.updateUserLocale, serverLocale);

  // success?
  if (response.ok) {
    console.log('UpdateUserLocaleSaga: API call successful, updating Redux state');
    
    // Update the locale update state
    yield put(UpdateUserLocaleActions.updateUserLocaleSuccess(response.data));
    
    // OPTIMIZATION: Update getMe state directly from the response data
    // No need for a second API call - the response already contains updated user data
    if ( response.data ) { // && response.data.locale
      const { status, locale: serverLocale, settings } = response.data;
      
      // Map server language keys back to frontend keys
      let frontendLocale = serverLocale;
      if (serverLocale === 'hk') {
        frontendLocale = 'zh'; // Server returns 'hk', frontend needs 'zh'
        console.log('UpdateUserLocaleSaga: Mapped server hk -> frontend zh');
      } else if (serverLocale === 'en') {
        frontendLocale = 'en'; // Server returns 'en', frontend needs 'en'
        console.log('UpdateUserLocaleSaga: Using server en for frontend');
      } else {
        console.warn('UpdateUserLocaleSaga: Unknown server locale, using as-is:', serverLocale);
      }      
      
      yield put(GetMeActions.getMeSuccess(status, frontendLocale, settings));
    } else {
      console.log('UpdateUserLocaleSaga: Response data does not contain locale info, skipping getMe update');
    }
  } else {
    console.error('UpdateUserLocaleSaga: API call failed');
    yield put(UpdateUserLocaleActions.updateUserLocaleFailure());
  }
}